module.exports = __webpack_public_path__ + "img/Irene.6b1afd48.jpg";